import { LogRoot_getInstance3817ahbflvs01 as LogRoot_getInstance } from '../debugger.js.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  zipfdxxupzuj2p9 as zip,
  dropLast1vpiyky649o34 as dropLast,
  first58ocm7j58k3q as first,
  plus20p0vtfmu0596 as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  emptyList1g2z5xcrvp2zy as emptyList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
  Char__plus_impl_qi7pgj3akekecdud2w6 as Char__plus_impl_qi7pgj,
  toString3o7ifthqydp6e as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../reactive/PersistentProperty.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  plus2lr02ok6jhhxu as plus_0,
  minus1f3bieyodk5vw as minus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  substringAfter35b3qhto7hchb as substringAfter,
  substringAfter1hku067gwr5ve as substringAfter_0,
  removePrefix279df90bhrqqg as removePrefix,
  split3d3yeauc4rm2n as split,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart1mkod6gyztuyy as trimStart,
  substringBefore3n7kj60w69hju as substringBefore,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  UrlLikePath1l4lcedbwd0yq as UrlLikePath,
  Companion_getInstance3qvaw4651ntmp as Companion_getInstance,
} from './Routes.mjs';
import { Companion_getInstanceok5aued8gko9 as Companion_getInstance_0 } from '../debugger.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_basePath() {
  _init_properties_Navigator_js_kt__1lm31c();
  return basePath;
}
var basePath;
function bindToPlatform(_this__u8e3s4, context) {
  _init_properties_Navigator_js_kt__1lm31c();
  switch (Companion_getInstance_1().ndo_1.b4_1) {
    case 0:
      var log = LogRoot_getInstance().zbm('ScreenStack.bindToPlatform');
      var lastStackForPath = HashMap().n8();
      var initBar = urlLike(window.location);
      bindToPlatform$guessAndImplementFromUrlBar(_this__u8e3s4, lastStackForPath, initBar);
      var suppressNav = {_v: false};
      var tmp = window;
      tmp.addEventListener('popstate', (event) => {
        var tmp;
        if (suppressNav._v) {
          return Unit_instance;
        }
        if (!(event instanceof PopStateEvent))
          THROW_CCE();
        var tmp_0;
        try {
          suppressNav._v = true;
          bindToPlatform$guessAndImplementFromUrlBar(_this__u8e3s4, lastStackForPath, urlLike(window.location));
          tmp_0 = Unit_instance;
        }finally {
          suppressNav._v = false;
        }
        return Unit_instance;
      });
      var lastStack = {_v: _this__u8e3s4.gbn_1.f2()};
      var tmp_0 = get_AppScope();
      reactiveScope(tmp_0, ($this$reactiveScope) => {
        var s = $this$reactiveScope.baj(_this__u8e3s4.gbn_1);
        var tmp;
        if (suppressNav._v) {
          return Unit_instance;
        }
        var tmp_0;
        try {
          suppressNav._v = true;
          var tmp_1;
          if (!equals(lastOrNull(s), lastOrNull(lastStack._v))) {
            var tmp0_elvis_lhs = lastOrNull(s);
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }
            var new_0 = tmp_2;
            var tmp1_safe_receiver = _this__u8e3s4.jbw().nbw(new_0);
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.obw_1;
            if (tmp2_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              var tmp0_safe_receiver = log;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.fcv(["pushState '" + tmp2_safe_receiver.sbw() + "'..."]);
              }
              window.history.pushState(null, '', get_basePath() + tmp2_safe_receiver.sbw());
            }
            tmp_1 = Unit_instance;
          }
          tmp_0 = tmp_1;
        }finally {
          suppressNav._v = false;
        }
        return Unit_instance;
      });
      var tmp_1 = get_AppScope();
      reactiveScope(tmp_1, ($this$reactiveScope) => {
        var s = $this$reactiveScope.baj(_this__u8e3s4.gbn_1);
        var tmp0_safe_receiver = lastOrNull(s);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = _this__u8e3s4.jbw().nbw(tmp0_safe_receiver);
        }
        var tmp1_safe_receiver = tmp;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          $l$block: {
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp1_safe_receiver.pbw_1.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              $this$reactiveScope.aaj(element);
            }
            if (suppressNav._v) {
              break $l$block;
            }
            var tmp0_safe_receiver_0 = log;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.fcv(['Replacing state as index ' + get_lastIndex(s) + " with '" + tmp1_safe_receiver.obw_1.sbw() + "'"]);
            }
            // Inline function 'kotlin.let' call
            var it = tmp1_safe_receiver.obw_1;
            window.history.replaceState(get_lastIndex(s), '', get_basePath() + it.sbw());
            var tmp0 = lastStackForPath;
            // Inline function 'kotlin.collections.set' call
            var key = tmp1_safe_receiver.obw_1;
            tmp0.s3(key, s);
          }
        }
        return Unit_instance;
      });
      var tmp_2 = get_AppScope();
      reactive(tmp_2, ($this$reactive) => {
        var tmp = document;
        var tmp0_safe_receiver = lastOrNull($this$reactive.baj(_this__u8e3s4.gbn_1));
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ucv();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : $this$reactive.baj(tmp1_safe_receiver);
        tmp.title = tmp2_elvis_lhs == null ? 'App' : tmp2_elvis_lhs;
        return Unit_instance;
      });
      break;
    case 1:
      var log_0 = LogRoot_getInstance().zbm('ScreenStack.bindToPlatform');
      var initBar_0 = urlLike(window.location);
      var tmp0 = 'last-stack-id';
      // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call

      var defaultValue = _Char___init__impl__6a9atx(97);
      // Inline function 'kotlinx.serialization.serializer' call

      // Inline function 'kotlinx.serialization.internal.cast' call

      var this_0 = serializer(createKType(getKClass(Char()), arrayOf([]), false));
      var tmp$ret$12 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
      var nextStackId = PersistentProperty().od8(tmp0, new (Char())(defaultValue), tmp$ret$12);
      var tmp1_elvis_lhs = initBar_0.rbw_1.p3('s');
      var tmp_3;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_1 = nextStackId.f2();
        var it = this_1.z2_1;
        nextStackId.mam(new (Char())(Char__plus_impl_qi7pgj(it, 1)));
        var tmp$ret$15 = this_1.z2_1;
        tmp_3 = toString_0(tmp$ret$15);
      } else {
        tmp_3 = tmp1_elvis_lhs;
      }

      var currentStackId = tmp_3;
      var tmp0_0 = 'main-stack-' + currentStackId;
      // Inline function 'kotlin.collections.listOf' call

      // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call

      var defaultValue_0 = emptyList();
      // Inline function 'kotlinx.serialization.serializer' call

      // Inline function 'kotlinx.serialization.internal.cast' call

      var this_2 = serializer(createKType(getKClass(KtList()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false))]), false));
      var tmp$ret$18 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
      var tmp_4 = PersistentProperty().od8(tmp0_0, defaultValue_0, tmp$ret$18);
      var tmp_5 = bindToPlatform$lambda;
      var currentStack = tmp_4.tak(tmp_5, bindToPlatform$lambda_0);
      bindToPlatform$guessAndImplementFromUrlBar_0(currentStack, log_0, _this__u8e3s4, initBar_0);
      var suppressNav_0 = {_v: false};
      var tmp_6 = window;
      tmp_6.addEventListener('popstate', (event) => {
        var tmp;
        if (suppressNav_0._v) {
          return Unit_instance;
        }
        if (!(event instanceof PopStateEvent))
          THROW_CCE();
        var tmp_0;
        try {
          suppressNav_0._v = true;
          var tmp_1 = event.state;
          var tmp0_safe_receiver = (tmp_1 == null ? true : typeof tmp_1 === 'number') ? tmp_1 : THROW_CCE();
          var tmp_2;
          if (tmp0_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_3;
            if (tmp0_safe_receiver < _this__u8e3s4.gbn_1.f2().p1()) {
              tmp_3 = tmp0_safe_receiver;
            } else {
              tmp_3 = null;
            }
            tmp_2 = tmp_3;
          }
          var tmp1_safe_receiver = tmp_2;
          var tmp_4;
          if (tmp1_safe_receiver == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_5;
            var tmp_6 = urlLike(window.location);
            var tmp0_safe_receiver_0 = _this__u8e3s4.jbw().nbw(_this__u8e3s4.gbn_1.f2().q1(tmp1_safe_receiver));
            if (tmp_6.equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.obw_1)) {
              tmp_5 = tmp1_safe_receiver;
            } else {
              tmp_5 = null;
            }
            tmp_4 = tmp_5;
          }
          var tmp2_safe_receiver = tmp_4;
          var tmp_7;
          if (tmp2_safe_receiver == null) {
            tmp_7 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_1 = log_0;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              tmp0_safe_receiver_1.fcv(['popstate pops back to index ' + tmp2_safe_receiver]);
            }
            _this__u8e3s4.gbn_1.mam(_this__u8e3s4.gbn_1.f2().m3(0, tmp2_safe_receiver + 1 | 0));
            tmp_7 = Unit_instance;
          }
          var tmp3_elvis_lhs = tmp_7;
          var tmp_8;
          if (tmp3_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var tmp0_safe_receiver_2 = log_0;
            if (tmp0_safe_receiver_2 == null)
              null;
            else {
              tmp0_safe_receiver_2.fcv(['popstate is going to match the best it can']);
            }
            bindToPlatform$guessAndImplementFromUrlBar_0(currentStack, log_0, _this__u8e3s4, urlLike(window.location));
            tmp_8 = Unit_instance;
          } else {
            tmp_8 = tmp3_elvis_lhs;
          }
          tmp_0 = tmp_8;
        }finally {
          suppressNav_0._v = false;
        }
        return Unit_instance;
      });
      var tmp_7 = get_AppScope();
      reactiveScope(tmp_7, ($this$reactiveScope) => {
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = $this$reactiveScope.baj(_this__u8e3s4.gbn_1);
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().w();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = _this__u8e3s4.jbw().nbw(element);
          var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.obw_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.v(tmp0_safe_receiver_0);
          }
        }
        currentStack.mam(destination);
        return Unit_instance;
      });
      var lastStack_0 = {_v: _this__u8e3s4.gbn_1.f2()};
      var tmp_8 = get_AppScope();
      reactiveScope(tmp_8, ($this$reactiveScope) => {
        suppressNav_0._v = true;
        var tmp;
        try {
          var s = $this$reactiveScope.baj(_this__u8e3s4.gbn_1);
          if (!suppressNav_0._v) {
            var tmp0 = zip(s, lastStack_0._v);
            var tmp$ret$36;
            $l$block_0: {
              // Inline function 'kotlin.collections.indexOfFirst' call
              var index = 0;
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var item = _iterator__ex2g4s.o1();
                if (!equals(item.af_1, item.bf_1)) {
                  tmp$ret$36 = index;
                  break $l$block_0;
                }
                index = index + 1 | 0;
              }
              tmp$ret$36 = -1;
            }
            var indexWhereChangesStart = tmp$ret$36;
            if (indexWhereChangesStart === -1) {
              var tmp0_0 = s.p1();
              // Inline function 'kotlin.math.min' call
              var b = lastStack_0._v.p1();
              indexWhereChangesStart = Math.min(tmp0_0, b);
            }
            var removed = lastStack_0._v.m3(indexWhereChangesStart, lastStack_0._v.p1());
            var added = s.m3(indexWhereChangesStart, s.p1());
            if (removed.i1() && added.i1())
              return Unit_instance;
            var tmp0_safe_receiver = log_0;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.fcv(['Nav changed!  Removed ' + toString(removed) + ', added ' + toString(added)]);
            }
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!removed.i1()) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              tmp_0 = !added.i1();
            } else {
              tmp_0 = false;
            }
            var canDoSwap = tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!removed.i1()) {
              var toRemove = canDoSwap ? dropLast(removed, 1) : removed;
              var _iterator__ex2g4s_0 = toRemove.m1();
              $l$loop: while (_iterator__ex2g4s_0.n1()) {
                var item_0 = _iterator__ex2g4s_0.o1();
                var rendered = _this__u8e3s4.jbw().nbw(item_0);
                if (rendered == null)
                  continue $l$loop;
                var tmp1_safe_receiver = log_0;
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  var tmp3_safe_receiver = rendered == null ? null : rendered.obw_1;
                  tmp1_safe_receiver.fcv(["Popping off (we hope) '" + (tmp3_safe_receiver == null ? null : tmp3_safe_receiver.sbw()) + "'..."]);
                }
                window.history.back();
              }
            }
            if (canDoSwap) {
              var tmp4_safe_receiver = _this__u8e3s4.jbw().nbw(first(added));
              var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.obw_1;
              var tmp_1;
              if (tmp5_elvis_lhs == null) {
                return Unit_instance;
              } else {
                tmp_1 = tmp5_elvis_lhs;
              }
              var it = tmp_1;
              var tmp6_safe_receiver = log_0;
              if (tmp6_safe_receiver == null)
                null;
              else {
                tmp6_safe_receiver.fcv(["Swapping '" + it.sbw() + "'..."]);
              }
              window.history.replaceState(get_lastIndex(_this__u8e3s4.gbn_1.f2()), '', get_basePath() + it.dd7(VOID, plus_0(it.rbw_1, to('s', currentStackId))).sbw());
            }
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!added.i1()) {
              var iterator = added.m1();
              var index_0 = 0;
              $l$loop_0: while (iterator.n1()) {
                var index_1 = index_0;
                index_0 = index_0 + 1 | 0;
                var new_0 = iterator.o1();
                if (canDoSwap && index_1 === 0)
                  continue $l$loop_0;
                var tmp7_safe_receiver = _this__u8e3s4.jbw().nbw(new_0);
                var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.obw_1;
                if (tmp8_safe_receiver == null)
                  null;
                else {
                  // Inline function 'kotlin.let' call
                  var tmp0_safe_receiver_0 = log_0;
                  if (tmp0_safe_receiver_0 == null)
                    null;
                  else {
                    tmp0_safe_receiver_0.fcv(["Pushing (we hope) '" + tmp8_safe_receiver.sbw() + "' as index " + (index_1 + indexWhereChangesStart | 0) + '...']);
                  }
                  window.history.pushState(index_1 + indexWhereChangesStart | 0, '', get_basePath() + tmp8_safe_receiver.dd7(VOID, plus_0(tmp8_safe_receiver.rbw_1, to('s', currentStackId))).sbw());
                }
              }
            }
          }
          lastStack_0._v = s;
          tmp = Unit_instance;
        }finally {
          suppressNav_0._v = false;
        }
        return Unit_instance;
      });
      var tmp_9 = get_AppScope();
      reactiveScope(tmp_9, ($this$reactiveScope) => {
        var s = $this$reactiveScope.baj(_this__u8e3s4.gbn_1);
        var tmp0_safe_receiver = lastOrNull(s);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = _this__u8e3s4.jbw().nbw(tmp0_safe_receiver);
        }
        var tmp1_safe_receiver = tmp;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          $l$block_1: {
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp1_safe_receiver.pbw_1.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              $this$reactiveScope.aaj(element);
            }
            if (suppressNav_0._v) {
              break $l$block_1;
            }
            var tmp0_safe_receiver_0 = log_0;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.fcv(['Replacing state as index ' + get_lastIndex(s) + " with '" + tmp1_safe_receiver.obw_1.sbw() + "'"]);
            }
            // Inline function 'kotlin.let' call
            var it = tmp1_safe_receiver.obw_1;
            window.history.replaceState(get_lastIndex(s), '', get_basePath() + it.dd7(VOID, plus_0(it.rbw_1, to('s', currentStackId))).sbw());
          }
        }
        return Unit_instance;
      });
      var tmp_10 = get_AppScope();
      reactive(tmp_10, ($this$reactive) => {
        var tmp = document;
        var tmp0_safe_receiver = lastOrNull($this$reactive.baj(_this__u8e3s4.gbn_1));
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ucv();
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : $this$reactive.baj(tmp1_safe_receiver);
        tmp.title = tmp2_elvis_lhs == null ? 'App' : tmp2_elvis_lhs;
        return Unit_instance;
      });
      break;
    case 2:
      var log_1 = LogRoot_getInstance().zbm('ScreenStack.bindToPlatform');
      var tmp0_1 = 'main-stack';
      // Inline function 'kotlin.collections.listOf' call

      // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call

      var defaultValue_1 = emptyList();
      // Inline function 'kotlinx.serialization.serializer' call

      // Inline function 'kotlinx.serialization.internal.cast' call

      var this_3 = serializer(createKType(getKClass(KtList()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false))]), false));
      var tmp$ret$54 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
      var storedStack = PersistentProperty().od8(tmp0_1, defaultValue_1, tmp$ret$54);
      bindToPlatform$guessAndImplementFromUrlBar_1(storedStack, log_1, _this__u8e3s4);
      var suppressNav_1 = {_v: false};
      var tmp_11 = window;
      tmp_11.addEventListener('popstate', (event) => {
        var tmp;
        if (suppressNav_1._v) {
          return Unit_instance;
        }
        if (!(event instanceof PopStateEvent))
          THROW_CCE();
        var tmp_0;
        try {
          suppressNav_1._v = true;
          var tmp_1 = event.state;
          var tmp0_safe_receiver = (tmp_1 == null ? true : typeof tmp_1 === 'number') ? tmp_1 : THROW_CCE();
          var tmp_2;
          if (tmp0_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_3;
            if (tmp0_safe_receiver < _this__u8e3s4.gbn_1.f2().p1()) {
              tmp_3 = tmp0_safe_receiver;
            } else {
              tmp_3 = null;
            }
            tmp_2 = tmp_3;
          }
          var tmp1_safe_receiver = tmp_2;
          var tmp_4;
          if (tmp1_safe_receiver == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_5;
            var tmp_6 = urlLike(window.location);
            var tmp0_safe_receiver_0 = _this__u8e3s4.jbw().nbw(_this__u8e3s4.gbn_1.f2().q1(tmp1_safe_receiver));
            if (tmp_6.equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.obw_1)) {
              tmp_5 = tmp1_safe_receiver;
            } else {
              tmp_5 = null;
            }
            tmp_4 = tmp_5;
          }
          var tmp2_safe_receiver = tmp_4;
          var tmp_7;
          if (tmp2_safe_receiver == null) {
            tmp_7 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_1 = log_1;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              tmp0_safe_receiver_1.fcv(['popstate pops back to index ' + tmp2_safe_receiver]);
            }
            _this__u8e3s4.gbn_1.mam(_this__u8e3s4.gbn_1.f2().m3(0, tmp2_safe_receiver + 1 | 0));
            tmp_7 = Unit_instance;
          }
          var tmp3_elvis_lhs = tmp_7;
          var tmp_8;
          if (tmp3_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var tmp0_safe_receiver_2 = log_1;
            if (tmp0_safe_receiver_2 == null)
              null;
            else {
              tmp0_safe_receiver_2.fcv(['popstate is going to match the best it can']);
            }
            bindToPlatform$guessAndImplementFromUrlBar_1(storedStack, log_1, _this__u8e3s4);
            tmp_8 = Unit_instance;
          } else {
            tmp_8 = tmp3_elvis_lhs;
          }
          tmp_0 = tmp_8;
        }finally {
          suppressNav_1._v = false;
        }
        return Unit_instance;
      });
      var tmp_12 = get_AppScope();
      reactiveScope(tmp_12, ($this$reactiveScope) => {
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0 = $this$reactiveScope.baj(_this__u8e3s4.gbn_1);
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList().w();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = _this__u8e3s4.jbw().nbw(element);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.obw_1;
          var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.sbw();
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.v(tmp0_safe_receiver_0);
          }
        }
        storedStack.mam(destination);
        return Unit_instance;
      });
      var lastStack_1 = {_v: _this__u8e3s4.gbn_1.f2()};
      var tmp_13 = get_AppScope();
      reactiveScope(tmp_13, ($this$reactiveScope) => {
        var s = $this$reactiveScope.baj(_this__u8e3s4.gbn_1);
        var tmp;
        if (!suppressNav_1._v) {
          var tmp0 = zip(s, lastStack_1._v);
          var tmp$ret$72;
          $l$block_2: {
            // Inline function 'kotlin.collections.indexOfFirst' call
            var index = 0;
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var item = _iterator__ex2g4s.o1();
              if (!equals(item.af_1, item.bf_1)) {
                tmp$ret$72 = index;
                break $l$block_2;
              }
              index = index + 1 | 0;
            }
            tmp$ret$72 = -1;
          }
          var indexWhereChangesStart = tmp$ret$72;
          if (indexWhereChangesStart === -1) {
            var tmp0_0 = s.p1();
            // Inline function 'kotlin.math.min' call
            var b = lastStack_1._v.p1();
            indexWhereChangesStart = Math.min(tmp0_0, b);
          }
          var removed = lastStack_1._v.m3(indexWhereChangesStart, lastStack_1._v.p1());
          var added = s.m3(indexWhereChangesStart, s.p1());
          var tmp0_safe_receiver = log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.fcv(['Nav changed!  Removed ' + toString(removed) + ', added ' + toString(added)]);
          }
          var tmp_0;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!added.i1()) {
            var iterator = added.m1();
            var index_0 = 0;
            while (iterator.n1()) {
              var index_1 = index_0;
              index_0 = index_0 + 1 | 0;
              var new_0 = iterator.o1();
              var tmp1_safe_receiver = _this__u8e3s4.jbw().nbw(new_0);
              var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.obw_1;
              var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.sbw();
              if (tmp3_safe_receiver == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                var tmp0_safe_receiver_0 = log_1;
                if (tmp0_safe_receiver_0 == null)
                  null;
                else {
                  tmp0_safe_receiver_0.fcv(['Pushing ' + tmp3_safe_receiver + ' as index ' + (index_1 + indexWhereChangesStart | 0) + '...']);
                }
                window.history.pushState(index_1 + indexWhereChangesStart | 0, '', get_basePath() + tmp3_safe_receiver);
              }
            }
            tmp_0 = Unit_instance;
          }
          tmp = tmp_0;
        }
        lastStack_1._v = s;
        return Unit_instance;
      });
      var tmp_14 = get_AppScope();
      reactiveScope(tmp_14, ($this$reactiveScope) => {
        var s = $this$reactiveScope.baj(_this__u8e3s4.gbn_1);
        var tmp0_safe_receiver = lastOrNull(s);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = _this__u8e3s4.jbw().nbw(tmp0_safe_receiver);
        }
        var tmp1_safe_receiver = tmp;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp1_safe_receiver.pbw_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            $this$reactiveScope.aaj(element);
          }
          var tmp0_safe_receiver_0 = log_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.fcv(['Replacing  state as index ' + get_lastIndex(s)]);
          }
          window.history.replaceState(get_lastIndex(s), '', get_basePath() + tmp1_safe_receiver.obw_1.sbw());
        }
        return Unit_instance;
      });
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
var PageNavigatorBehavior_Separate_instance;
var PageNavigatorBehavior_Link_instance;
var PageNavigatorBehavior_Deprecated_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ndo_1 = PageNavigatorBehavior_Separate_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  PageNavigatorBehavior_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var PageNavigatorBehavior_entriesInitialized;
function PageNavigatorBehavior_initEntries() {
  if (PageNavigatorBehavior_entriesInitialized)
    return Unit_instance;
  PageNavigatorBehavior_entriesInitialized = true;
  PageNavigatorBehavior_Separate_instance = PageNavigatorBehavior().qdo('Separate', 0);
  PageNavigatorBehavior_Link_instance = PageNavigatorBehavior().qdo('Link', 1);
  PageNavigatorBehavior_Deprecated_instance = PageNavigatorBehavior().qdo('Deprecated', 2);
  Companion_getInstance_1();
}
var PageNavigatorBehaviorClass;
function PageNavigatorBehavior() {
  if (PageNavigatorBehaviorClass === VOID) {
    class $ extends Enum() {
      static qdo(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'PageNavigatorBehavior');
    PageNavigatorBehaviorClass = $;
  }
  return PageNavigatorBehaviorClass;
}
function urlLike(_this__u8e3s4) {
  _init_properties_Navigator_js_kt__1lm31c();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = split(removePrefix(_this__u8e3s4.pathname, '/' + substringAfter_0(substringAfter(get_basePath(), '://'), _Char___init__impl__6a9atx(47))), charArrayOf([_Char___init__impl__6a9atx(47)]));
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(element)) {
      destination.v(element);
    }
  }
  var tmp = destination;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = split(trimStart(_this__u8e3s4.search, charArrayOf([_Char___init__impl__6a9atx(63)])), charArrayOf([_Char___init__impl__6a9atx(38)]));
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = tmp0_0.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(element_0)) {
      destination_0.v(element_0);
    }
  }
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_1 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_1 = destination_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_1 = _iterator__ex2g4s_1.o1();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(substringBefore(element_1, _Char___init__impl__6a9atx(61)), decodeURIComponent(substringAfter_0(element_1, _Char___init__impl__6a9atx(61))));
    destination_1.s3(pair.af_1, pair.bf_1);
  }
  return new (UrlLikePath())(tmp, destination_1);
}
function bindToPlatform$guessAndImplementFromUrlBar($this_bindToPlatform, lastStackForPath, urlLikePath) {
  // Inline function 'kotlin.collections.getOrPut' call
  var value = lastStackForPath.p3(urlLikePath);
  var tmp;
  if (value == null) {
    var answer = listOf($this_bindToPlatform.jbw().yd6(urlLikePath));
    lastStackForPath.s3(urlLikePath, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  var tmp$ret$1 = tmp;
  $this_bindToPlatform.gbn_1.mam(tmp$ret$1);
}
function bindToPlatform$guessAndImplementFromUrlBar_0(currentStack, log, $this_bindToPlatform, urlLikePath) {
  var fixed = urlLikePath.dd7(VOID, minus(urlLikePath.rbw_1, 's'));
  var tmp0 = currentStack.f2();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfLast' call
    var iterator = tmp0.u1(tmp0.p1());
    while (iterator.v6()) {
      if (iterator.x6().equals(fixed)) {
        tmp$ret$1 = iterator.w6();
        break $l$block;
      }
    }
    tmp$ret$1 = -1;
  }
  var index = tmp$ret$1;
  if (index === -1) {
    if (log == null)
      null;
    else {
      log.fcv(["guessAndImplementFromUrlBar: appending new value '" + fixed.toString() + "'"]);
    }
    currentStack.mam(plus(currentStack.f2(), fixed));
  } else {
    if (log == null)
      null;
    else {
      log.fcv(['guessAndImplementFromUrlBar: loading stack position ' + index]);
    }
    currentStack.mam(currentStack.f2().m3(0, index + 1 | 0));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = currentStack.f2();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$2 = $this_bindToPlatform.jbw().yd6(item);
    destination.v(tmp$ret$2);
  }
  $this_bindToPlatform.gbn_1.mam(destination);
}
function bindToPlatform$guessAndImplementFromUrlBar_1(storedStack, log, $this_bindToPlatform) {
  var urlBar = urlLike(window.location);
  var tmp0 = storedStack.f2();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfLast' call
    var iterator = tmp0.u1(tmp0.p1());
    while (iterator.v6()) {
      var it = iterator.x6();
      if (Companion_getInstance().bd7(it).equals(urlBar)) {
        tmp$ret$1 = iterator.w6();
        break $l$block;
      }
    }
    tmp$ret$1 = -1;
  }
  var goToIndex = tmp$ret$1;
  if (log == null)
    null;
  else {
    log.fcv(['Finding ' + urlBar.toString() + ' in ' + toString(storedStack.f2()) + ', index ' + goToIndex]);
  }
  if (goToIndex === -1) {
    if (log == null)
      null;
    else {
      log.fcv(['Could not find, pushing']);
    }
    var newPage = $this_bindToPlatform.jbw().yd6(urlBar);
    // Inline function 'kotlin.collections.map' call
    var this_0 = storedStack.f2();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$2 = $this_bindToPlatform.jbw().yd6(Companion_getInstance().bd7(item));
      destination.v(tmp$ret$2);
    }
    $this_bindToPlatform.gbn_1.mam(plus(destination, newPage));
    var tmp2_safe_receiver = $this_bindToPlatform.jbw().nbw(newPage);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      storedStack.mam(plus(storedStack.f2(), tmp2_safe_receiver.obw_1.sbw()));
    }
  } else {
    if (log == null)
      null;
    else {
      log.fcv(['Found, popping backwards']);
    }
    storedStack.mam(storedStack.f2().m3(0, goToIndex + 1 | 0));
    // Inline function 'kotlin.collections.map' call
    var this_1 = storedStack.f2();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().u(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item_0 = _iterator__ex2g4s_0.o1();
      var tmp$ret$7 = $this_bindToPlatform.jbw().yd6(Companion_getInstance().bd7(item_0));
      destination_0.v(tmp$ret$7);
    }
    $this_bindToPlatform.gbn_1.mam(destination_0);
  }
}
function bindToPlatform$lambda(it) {
  _init_properties_Navigator_js_kt__1lm31c();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(it, 10));
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = Companion_getInstance().bd7(item);
    destination.v(tmp$ret$0);
  }
  return destination;
}
function bindToPlatform$lambda_0(it) {
  _init_properties_Navigator_js_kt__1lm31c();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(it, 10));
  var _iterator__ex2g4s = it.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.sbw();
    destination.v(tmp$ret$0);
  }
  return destination;
}
function PageNavigatorBehavior_Separate_getInstance() {
  PageNavigatorBehavior_initEntries();
  return PageNavigatorBehavior_Separate_instance;
}
var properties_initialized_Navigator_js_kt_v5tcse;
function _init_properties_Navigator_js_kt__1lm31c() {
  if (!properties_initialized_Navigator_js_kt_v5tcse) {
    properties_initialized_Navigator_js_kt_v5tcse = true;
    var tmp = document.getElementById('baseUrlLocation');
    var tmp0_safe_receiver = tmp instanceof HTMLScriptElement ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.innerText;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = JSON.parse(tmp1_safe_receiver).baseUrl;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.takeIf' call
      var this_0 = document.baseURI;
      var tmp_2;
      if (!(document.getElementsByTagName('base').length === 0)) {
        tmp_2 = this_0;
      } else {
        tmp_2 = null;
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_1;
    // Inline function 'kotlin.also' call
    var this_1 = tmp3_elvis_lhs == null ? '/' : tmp3_elvis_lhs;
    Companion_getInstance_0().abn(['Base path is ' + this_1]);
    basePath = this_1;
  }
}
//region block: exports
export {
  get_basePath as get_basePath37oh0bkfrtwru,
  bindToPlatform as bindToPlatformg7nl9tb6kj90,
};
//endregion

//# sourceMappingURL=Navigator.js.mjs.map
